<template>
  <div class="table-responsive" style="overflow-x: hidden;">
    <table class="table my-0" >
      <thead>
        <tr>
          <th
            v-for="column in columns"
            class="text-center"
            :key="column.id"
            style="text-transform: none !important;"
          >
            {{ column.name }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in data" :key="index">
            <td
              v-for="column in columns"
              class="text-center"
              :key="column.id"
            >
              <div
                class="row d-flex justify-content-center"
                v-if="itemValue(item, column) == 'actions'"
              >
                <div
                  v-for="button in buttons"
                  :key="button.id"
                  :class=" item.id_type_status == 2 || item.active == 1 && button.type_action !== 'open_modal' && button.action == 'openModalPayment' &&  item.id_type_status != 3 || item.active == 1 && button.type_action !== 'open_modal' && button.action == 'openModalPayment' &&  item.id_type_status == 3 && item.id_type_status_payment == 3 || item.active == 1 && button.type_action !== 'open_modal' && button.action == 'deleteStatus' && item.id_type_status != 1 ? 'w-0 p-0' : 'col-sm-4 d-flex justify-content-center' "
                >
                <div
                    v-if="
                      item.active == 1 && button.type_action !== 'open_modal' && button.action == 'deleteStatus' && item.id_type_status != 2
                    "
                  >
                    <button v-if="item.id_type_status == 1"
                      :style="' border-radius: 50% !important' + ';' + 'height: 40px !important' + ';' + 'background-color: ' + button.background_color"
                      type="button"
                      data-toggle="tooltip"
                      data-placement="top"
                      :title="button.tooltip"
                      :class="
                        'btn btn-sm btn-fill float-right m-1 white' +
                        button.type_button
                      "
                      @click.prevent="goAction(item, button)"
                    >
                      <v-icon
                        :style="{ color: button.fill_icon }"
                        :icon="['fas', button.icon]"
                      ></v-icon>
                    </button>
                  </div>
                  <div
                    v-else-if="
                      item.active == 1 && button.type_action !== 'open_modal' && button.action == 'openModalPayment' && item.id_type_status != 2
                    "
                  >
                    <button v-if="item.id_type_status == 3 && item.id_type_status_payment != 3"
                      :style="' border-radius: 50% !important' + ';' + 'height: 40px !important' + ';' + 'background-color: ' + button.background_color"
                      type="button"
                      data-toggle="tooltip"
                      data-placement="top"
                      :title="button.tooltip"
                      :class="
                        'btn btn-sm btn-fill float-right m-1 white' +
                        button.type_button
                      "
                      @click.prevent="goAction(item, button)"
                    >
                      <v-icon
                        :style="{ color: button.fill_icon }"
                        :icon="['fas', button.icon]"
                      ></v-icon>
                    </button>
                  </div>
                  <div
                    v-else-if="
                      item.active == 1 && button.type_action !== 'open_modal' && item.id_type_status != 2
                    "
                  >
                    <button
                      :style="' border-radius: 50% !important' + ';' + 'height: 40px !important' + ';' + 'background-color: ' + button.background_color"
                      type="button"
                      data-toggle="tooltip"
                      data-placement="top"
                      :title="button.tooltip"
                      :class="
                        'btn btn-sm btn-fill float-right m-1 white' +
                        button.type_button
                      "
                      @click.prevent="goAction(item, button)"
                    >
                      <v-icon
                        :style="{ color: button.fill_icon }"
                        :icon="['fas', button.action === 'openUploadElement' ? 'eye' : button.icon]"
                      ></v-icon>
                    </button>
                  </div>

                  <div
                    v-if="
                      item.active == 2 && button.type_action !== 'open_modal'
                    "
                  >
                    <button
                      style="
                        border-radius: 50% !important;
                        height: 40px !important;
                      "
                      type="button"
                      data-toggle="tooltip"
                      data-placement="top"
                      :title="button.tooltip"
                      :class="
                        'btn btn-sm btn-fill float-right m-1 white' +
                        button.type_button
                      "
                      @click.prevent="goAction(item, button)"
                    >
                      <v-icon
                        :fill="button.fill_icon"
                        :name="button.icon"
                      ></v-icon>
                    </button>
                  </div>

                  <div
                    v-if="
                      item.active == 0 && button.type_action !== 'open_modal'
                    "
                  >
                    <button
                      style="
                        border-radius: 50% !important;
                        height: 40px !important;
                      "
                      type="button"
                      data-toggle="tooltip"
                      data-placement="top"
                      :title="button.tooltip"
                      :class="
                        'btn btn-sm btn-fill float-right m-1 white' +
                        button.type_button
                      "
                      @click.prevent="goAction(item, button)"
                    >
                      <v-icon
                        :style="{ color: '#cccccc' }"
                        :icon="['fas', button.icon_negative]"
                      ></v-icon>
                    </button>
                  </div>

                  <div v-if="button.type_action == 'open_modal'">
                    <button
                      type="button"
                      data-bs-toggle="modal"
                      data-toggle="tooltip"
                      :data-bs-target="'#' + button.modal_id + item.id"
                      data-placement="top"
                      :title="button.tooltip"
                      :class="
                        'btn btn-sm btn-fill float-right m-1 ' +
                        button.type_button
                      "
                    >
                      <v-icon :style="{ color: 'white' }" :icon="['fas', button.icon]"></v-icon>
                    </button>

                    <!-- Modal -->
                    <div
                      class="modal fade"
                      :ref="'myModal' + item.id"
                      :id="button.modal_id + item.id"
                      tabindex="-1"
                      aria-labelledby="exampleModalLabel"
                      aria-hidden="true"
                    >
                      <div class="modal-dialog">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h1 class="modal-title fs-5" id="exampleModalLabel">
                              {{ button.modal_title }}
                            </h1>
                            <button
                              type="button"
                              class="btn-close"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            ></button>
                          </div>
                          <div class="modal-body">
                            <div
                              :class="'col-md-' + form.col"
                              v-for="form in button.fields"
                              :key="form.id"
                            >
                              <div class="mb-3" v-if="form.hide != true">
                                <label
                                  for="exampleFormControlInput1"
                                  class="form-label"
                                  >{{ form.label }}</label
                                >
                                <div v-if="form.type == 'input'">
                                  <input
                                    v-model="form.value"
                                    :type="
                                      form.typeinput ? form.typeinput : 'text'
                                    "
                                    class="form-control"
                                    :id="'Input' + form.label"
                                    :placeholder="form.placeholder"
                                  />
                                </div>

                                <div v-if="form.type == 'textarea'">
                                  <textarea
                                    :disabled="form.disabled"
                                    v-model="form.value"
                                    :type="
                                      form.typeinput ? form.typeinput : 'text'
                                    "
                                    class="form-control"
                                    :id="'Input' + form.label"
                                    :placeholder="form.placeholder"
                                  />
                                </div>

                                <div v-if="form.type == 'date'">
                                  <date-picker
                                    v-model="form.value"
                                    class="mb-1 pb-1 w-100"
                                    :id="'Input' + form.label"
                                    :placeholder="form.placeholder"
                                    valueType="format"
                                  ></date-picker>
                                </div>

                                <div v-if="form.type == 'select'">
                                  <multiselect
                                    selectLabel="Click/enter para elegir"
                                    selectedLabel="Seleccionado"
                                    deselectLabel="Enter para remover"
                                    v-if="simpleStringCheck(form.select_label)"
                                    v-model="form.value"
                                    :label="form.select_label"
                                    :options="form.items"
                                    :select-label="'Seleccionar'"
                                    placeholder="Seleccione"
                                  >
                                    <span slot="noResult">
                                      No hay resultados
                                    </span>
                                    <span slot="noOptions">
                                      No hay resultados
                                    </span>
                                  </multiselect>
                                  <multiselect
                                    selectLabel="Click/enter para elegir"
                                    selectedLabel="Seleccionado"
                                    deselectLabel="Enter para remover"
                                    v-else
                                    v-model="form.value"
                                    :options="form.items"
                                    :select-label="'Seleccionar'"
                                    placeholder="Seleccione"
                                  >
                                    <template
                                      slot="singleLabel"
                                      slot-scope="{ option }"
                                    >
                                      <span>
                                        {{
                                          handleLabel(form.select_label, option)
                                        }}</span
                                      >
                                    </template>
                                    <template
                                      slot="option"
                                      slot-scope="{ option }"
                                    >
                                      {{
                                        handleLabel(form.select_label, option)
                                      }}
                                    </template>
                                    <span slot="noResult">
                                      No hay resultados
                                    </span>
                                    <span slot="noOptions">
                                      No hay resultados
                                    </span>
                                  </multiselect>
                                </div>
                                <div v-if="form.type == 'file'">
                                  <file-pond
                                    ref="filePond"
                                    :allow-multiple="form.multiple"
                                    accepted-file-types="image/jpeg, image/png"
                                    name="image"
                                    v-model="form.value"
                                    :label-idle="form.placeholder"
                                  ></file-pond>
                                </div>
                                <div v-if="form.type == 'time'">
                                  <input
                                    v-model="form.value"
                                    type="time"
                                    class="form-control"
                                    :id="'Input' + form.label"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="modal-footer">
                            <button
                              type="button"
                              class="btn btn-secondary"
                              data-bs-dismiss="modal"
                            >
                              {{ button.cancel_label }}
                            </button>
                            <button
                              type="button"
                              class="btn btn-primary"
                              @click.prevent="goAction(item, button)"
                            >
                              {{ button.save_label }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div v-if="column.type == 'image'">
                  <img v-if="itemValue(item, column).length > 0"
                    :src="itemValue(item, column)"
                    style="max-width: 60px; width: 60px;  border-radius: 50%;
                        height: 60px; max-height: 60px; object-fit: cover !important;"
                    class="img-fluid"
                  />
                  <img v-else
                    src="../core_assets/img/ccdlogolite.png"
                    style="max-width: 60px; width: 60px;  border-radius: 50%;
                        height: 60px; max-height: 60px; object-fit: cover !important;"
                    class="img-fluid"
                  />
                </div>

                <div v-else>
                  <div v-if="column.type == 'link'">
                    <a :href="itemValue(item, column)" target="a_blank">Ver</a>
                    boolean_icon
                  </div>
                  <div v-if="column.type == 'prefix'">
                    {{ column.label }}{{ itemValue(item, column) }}
                    <button
                      type="button"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Crear nuevo"
                      :class="'btn btn-sm btn-fill float-right m-1 bg-gradient-fvf'"
                      @click.prevent="
                        copy(column.label + itemValue(item, column))
                      "
                    >
                      <span style="color: white">
                        <v-icon
                          :icon="['fas', 'clipboard-list']"
                          class="mx-1"
                          :style="{ color: 'white' }"
                        ></v-icon
                      ></span>
                    </button>
                  </div>
                  <div v-else>
                    <div v-if="column.type == 'boolean_icon'">
                      <span
                        v-if="itemValue(item, column) == '0'"
                        class="badge bg-secondary"
                        >Inactivo</span
                      >
                      <span
                        v-if="itemValue(item, column) == '1'"
                        class="badge bg-success"
                        >Activo</span
                      >
                    </div>
                    <div v-else>
                      <div v-if="column.type == 'boolean_multiple'">
                        <div v-for="option in column.options" :key="option.id">
                          <span v-if="option.id == itemValue(item, column)">
                            {{ option.value }}
                          </span>
                        </div>
                      </div>
                      <div v-if="column.type == 'hour'">
                        {{
                          moment(itemValue(item, column), "HH:mm").format(
                            "h:mm A"
                          )
                        }}
                      </div>
                      <div v-else>
                        <div v-if="column.type == 'date'">
                          {{
                            moment(itemValue(item, column)).format(
                              column.format_date
                            )
                          }}
                        </div>

                        <div v-else>
                          <div v-if="column.type == 'input'">
                                  <input
                                    v-model="value"
                                    :type="
                                      column.typeinput ? column.typeinput : 'text'
                                    "
                                    class="form-control"
                                    :id="'Input' + (column.label++)"
                                    :placeholder="column.placeholder"
                                  />
                                </div>
                          <div v-else>
                          {{ itemValue(item, column) }}
                        </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </td>
        </tr>
      </tbody>
    </table>

    <div class="row" v-if="showInfo">
      <div class="col-md-2">
        <p style="color: gray; font-size: 11px">
          Visualizando: {{ metaInfo.total }} Elementos
        </p>
      </div>
      <div class="col-md-2">
        <p class="float-right" style="color: gray; font-size: 11px">
          Página: {{ metaInfo.current_page }}
        </p>
      </div>
    </div>
    <div class="row justify-content-center" v-if="showPagination">
      <div class="col">
        <ul class="pagination justify-content-center">
          <li
            class="page-item"
            :class="{ disabled: metaInfo.current_page === 1 }"
            @click="changePage('minus')"
          >
            <a class="page-link" aria-label="Previous">
              <!-- <span aria-hidden="true">&laquo;</span> -->
              <span>{{ move_back }} </span>
            </a>
          </li>
          <li
            class="page-item"
            :class="{ active: metaInfo.current_page === metaInfo.first_page }"
            @click="changePageByNumber(metaInfo.first_page)"
          >
            <a class="page-link">{{ metaInfo.first_page }}</a>
          </li>
          <li
            class="page-item"
            v-if="metaInfo.current_page > metaInfo.first_page + 2"
          >
            <a class="page-link">...</a>
          </li>
          <template v-for="pageNumber in displayedPages">
            <li
              class="page-item"
              :class="{ active: pageNumber === metaInfo.current_page }"
              @click="changePageByNumber(pageNumber)"
            >
              <a class="page-link">{{ pageNumber }}</a>
            </li>
          </template>
          <li
            class="page-item"
            v-if="metaInfo.last_page - metaInfo.current_page > 1"
          >
            <a class="page-link">...</a>
          </li>
          <li
            class="page-item"
            v-if="metaInfo.last_page !== 1"
            :class="{ active: metaInfo.current_page === metaInfo.last_page }"
            @click="changePageByNumber(metaInfo.last_page)"
          >
            <a class="page-link">{{ metaInfo.last_page }}</a>
          </li>
          <li
            class="page-item"
            :class="{ disabled: metaInfo.current_page === metaInfo.last_page }"
            @click="changePage('plus')"
          >
            <a class="page-link" aria-label="Next">
              <span> {{ move_next }} </span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
);

import { mapActions } from "vuex";
import Multiselect from "vue-multiselect";

export default {
  name: "l-table",
  components: {
    Multiselect,
    FilePond,
  },
  props: {
    showInfo: {
      type: Boolean,
      default: true, // Valor por defecto para la prop miProp si no se especifica al utilizar el componente
    },
    showPagination: {
      showPagination: Boolean,
      default: true, // Valor por defecto para la prop miProp si no se especifica al utilizar el componente
    },

    columns: Array,
    data: Array,
    buttons: Array,
    changeStatus: Function,
    rejectedStatus: Function,
    deleteStatus: Function,

    metaInfo: Object,
    loadData: Function,
    openUpdateElement: Function,
    openUploadElement: Function,
    openModalPayment: Function,
  },

  data() {
    return {
      move_next: ">",
      move_back: "<",
    };
  },
  computed: {
    displayedPages() {
      const currentPage = this.metaInfo.current_page;
      const lastPage = this.metaInfo.last_page;
      const range = 2; // Número de páginas a mostrar a cada lado de la página actual

      const startPage = Math.max(
        currentPage - range,
        this.metaInfo.first_page + 1
      );
      const endPage = Math.min(currentPage + range, lastPage - 1);
      const pages = [];

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }

      return pages;
    },
  },
  methods: {
    copy(text) {
      const tempInput = document.createElement("input");
      tempInput.style.position = "fixed";
      tempInput.style.opacity = 0;
      tempInput.value = text;
      document.body.appendChild(tempInput);
      tempInput.focus();
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);
    },
    ...mapActions(["getData", "createData"]),
    hasValue(item, column) {
      if (!column || !column.key || !item) {
        return false;
      }

      const key = column.key;

      // Soportar llaves anidadas tipo "platform.name"
      if (key.includes(".")) {
        const sections = key.split(".");
        let value = item;

        for (let i = 0; i < sections.length; i++) {
          const section = sections[i];
          if (value && Object.prototype.hasOwnProperty.call(value, section)) {
            value = value[section];
          } else {
            return false;
          }
        }

        return value !== undefined && value !== null && value !== "";
      }

      const value = item[key];
      return value !== undefined && value !== null && value !== "";
    },

    itemValue(item, column) {
      if (column.key === "actions") {
        return "actions";
      } else if (column.type === "list") {
        const key = column.key;
        const itemId = item[key];
        const foundItem = column.items.find((item) => item.id === itemId);
        if (foundItem) {
          return foundItem.name;
        } else {
          return item[key];
        }
      } else {
        function getValueBySections(item, sections) {
          let value = item;
          for (let i = 0; i < sections.length; i++) {
            const section = sections[i];
            if (value && value.hasOwnProperty(section)) {
              value = value[section];
            } else {
              return "";
            }
          }
          return value;
        }

        const colum_key = column.key;
        const sections = colum_key.split('.');
        const value = getValueBySections(item, sections);

        if (column.hasOwnProperty("length")) {
          let data = value;
          let response = data.substring(0, column.length) + " ...";
          return response;
        } else {
          if (column.type == "image" && value == null) {
            return column.default_image;
          }
          return value;
        }
      }
    },
    changePageByNumber(page) {
      this.metaInfo.current_page = page;
      this.loadData();
    },
    changePage(type) {
      if (type == "plus") {
        if (this.metaInfo.current_page < this.metaInfo.last_page) {
          this.metaInfo.current_page += 1;
        }
        this.loadData();
      } else {
        if (this.metaInfo.current_page > this.metaInfo.first_page) {
          this.metaInfo.current_page -= 1;
        }
        this.loadData();
      }
    },
    goAction(data, button) {
      if (button.type_action == "go_url") {
        // if (button.url == "platform") {
        // this.$router.push({
        //   path: button.url + "/" + data.id,
        //   query: { id_type_status: data.id_type_status }
        // });
        // } else {
        this.$router.push(button.url + "/" + data.id);
        // }
      }
      if (button.type_action == "open_modal") {
        Swal.fire({
          title: button.modal_swa_title_label,
          text: this.save_description,
          icon: "question",
          reverseButtons: true,
          showCancelButton: true,
          confirmButtonColor: "#B49B57",
          cancelButtonColor: "#9F9F9F",
          cancelButtonText: button.modal_swa_cancel_label,
          confirmButtonText: button.modal_swa_confirm_label,
        }).then((result) => {
          if (result.value) {
            this.deleting = true;
            //LET PREPARING DATA
            let data_form = new FormData();

            for (let i in button.fields) {
              let form_element = button.fields[i];
              if (form_element.hide == true && form_element.use_item == true) {
                data_form.append(
                  form_element.vmodel_api,
                  data[form_element.use_key]
                );
              } else if (
                form_element.hide == true &&
                (form_element.use_item == false ||
                  form_element.use_item == undefined)
              ) {
                let defaultValue = form_element.vmodel_value_default;
                if (defaultValue != "" || defaultValue >= 0) {
                  data_form.append(
                    form_element.vmodel_api,
                    form_element.vmodel_value_default
                  );
                }
              } else if (form_element.type == "select") {
                if (form_element.value) {
                  data_form.append(
                    form_element.vmodel_api,
                    form_element.value.id
                  );
                } else {
                  // console.log(form_element.vmodel_value_default)
                  let defaultValue = form_element.vmodel_value_default;
                  if (defaultValue != "" || defaultValue >= 0) {
                    data_form.append(
                      form_element.vmodel_api,
                      form_element.vmodel_value_default
                    );
                  }
                }
              } else if (form_element.type == "check") {
                if (form_element.value == true) {
                  data_form.append(form_element.vmodel, 1);
                } else {
                  data_form.append(form_element.vmodel, 0);
                }
              } else if (form_element.type === "file") {
                const filePondInstance = this.$refs.filePond[0].getFiles();
                if (filePondInstance && filePondInstance[0].file) {
                  data_form.append(
                    form_element.vmodel,
                    form_element.value[0].file
                  );
                }
              } else {
                if (form_element.value) {
                  data_form.append(form_element.vmodel, form_element.value);
                }
              }
            }

            let data_to_save = {
              url: button.url,
              data: data_form,
            };
            this.createData(data_to_save)
              .then((response) => {
                if (response.code === 200) {
                  this.deleting = false;
                  Swal.fire({
                    title: "Notificación enviada con exito",
                    icon: "success",
                    showConfirmButton: false,
                    showLoaderOnConfirm: true,
                    timer: 1000,
                  });

                  for (let i = 0; i < button.fields.length; i++) {
                    const property = button.fields[i];
                    if (!property.hide) {
                      property.value = "";
                    }
                  }
                  this.$refs["myModal" + data.id][0].classList.remove("show");
                  document.body.classList.remove("modal-open"); // Remueve la clase 'modal-open' del body
                  document.querySelector(".modal-backdrop").remove();
                  // if (this.list_url != "") {
                  // this.$router.push({ name: this.list_url });
                  // }
                }
                if (response.code === 403) {
                  this.$toaster.warning(
                    "Ya existe un elemento con estos datos"
                  );
                }
                if (response.code === 409) {
                  this.$toaster.warning(
                    "Ya existe un elemento con estos datos"
                  );
                }
                if (response.code === 404) {
                  this.$toaster.warning("Ocurrio un error al enviar los datos");
                }
              })
              .catch((error) => {
                console.log(error);
                this.deleting = false;
                alert("Ocurrió un error, intente más tarde");
              });
          }
        });
      }
      if (button.type_action == "go_method") {
        if (button.action == "changeStatus") {
          this.changeStatus(data);
        }
        if (button.action == "rejectedStatus") {
          this.rejectedStatus(data);
        }
        if (button.action == "deleteStatus") {
          this.deleteStatus(data);
        }
      
        if (button.action == "openUpdateElement") {
          this.openUpdateElement(data);
        }

        if (button.action == "openUploadElement") {
          this.openUploadElement(data);
        }

        if (button.action == "openModalPayment") {
          this.openModalPayment(data);
        }
      }
    },
  },
};
</script>
<style></style>
